import { useEffect } from 'react';

import { useAppDispatch } from '@redux/hooks';
import { fetchProfile } from '@redux/auth';
import { useIsStandalonePage } from './useIsStandalonePage';

export const useFetchProfile = ({
  isAuthInitialized,
}: {
  isAuthInitialized: boolean;
}) => {
  const dispatch = useAppDispatch();
  const isStandalonePage = useIsStandalonePage();

  useEffect(() => {
    if (!isStandalonePage && isAuthInitialized) {
      dispatch(fetchProfile());
    }
  }, [isStandalonePage, isAuthInitialized, dispatch]);
};
